 import React from 'react'
import AboutUs from '../components/AboutUs'
import ServicesSection from '../components/ServicesSection'
import Programs from '../components/Programs'
import HeroSection from '../components/HeroSection'
import GoalsSection from '../components/GoalsSection'
import TeamSection from '../components/TeamSection'
 import "../styles/join-us.css"
 import "../styles/donation.css"
 import WhyItMatters from '../components/WhyItMatters'
 
 const Home = () => {
   return (
     <>
   <HeroSection/>

    <AboutUs/>

   
  
    <WhyItMatters/>

    <Programs/>
    <GoalsSection/>
    <ServicesSection/>

     
    <TeamSection/>
    
      </>
   )
 }
 
 export default Home